export default "__VITE_ASSET__f561f8af__"